module.exports = __webpack_public_path__ + "static/media/find_doc.80b83288.ico";